import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useUserContext } from '@module/mdrt-org/shared/components/providers/user-context';
import { OrgSharedDataTag } from '@module/mdrt-org/shared/utils/data/constants/tags';
import { getCompanyListing } from './get-company-listing';
import { type CompanyListingParams } from './types';
const DOWNLOAD_QUERY_KEY = [OrgSharedDataTag.GET_COMPANY_LISTING, 'all'];
export const useDownloadCompanyListingsQuery = params => {
  const $ = _c(16);
  const {
    accessToken
  } = useUserContext();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== accessToken || $[1] !== params) {
    t0 = t1 => {
      const {
        signal
      } = t1;
      return getCompanyListing(accessToken, params, signal);
    };
    $[0] = accessToken;
    $[1] = params;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== params) {
    t1 = [...DOWNLOAD_QUERY_KEY, params];
    $[3] = params;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      enabled: false,
      gcTime: 0,
      queryFn: t0,
      queryKey: t1,
      retry: false
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    isFetching,
    refetch
  } = useQuery(t2);
  let t3;
  if ($[8] !== queryClient) {
    t3 = () => queryClient.cancelQueries({
      queryKey: DOWNLOAD_QUERY_KEY
    });
    $[8] = queryClient;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const cancelDownload = t3;
  let t4;
  if ($[10] !== refetch) {
    t4 = async () => (await refetch()).data;
    $[10] = refetch;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== cancelDownload || $[13] !== isFetching || $[14] !== t4) {
    t5 = {
      cancelDownload,
      fetchAllListings: t4,
      isDownloading: isFetching
    };
    $[12] = cancelDownload;
    $[13] = isFetching;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};